import React from "react";
import image1 from "../../assets/images/First.jpg";
import image2 from "../../assets/images/Second.jpg";
import image3 from "../../assets/images/Third.jpg";
import image4 from "../../assets/images/Fourth.jpg";
import image5 from "../../assets/images/Five.jpg";
import image6 from "../../assets/images/Six.jpg";
import image7 from "../../assets/images/Seven.jpg";
import image8 from "../../assets/images/Eight.jpg";
import image9 from "../../assets/images/Nine.jpg";
import image10 from "../../assets/images/Ten.jpg";
import image11 from "../../assets/images/Eleven.jpg";
import image12 from "../../assets/images/Learn to code with AI-1.png";
import image14 from "../../assets/images/problem_solving_basic certificate (1)-1.png";
import image15 from "../../assets/images/Python Data Structures-1.png";
import image16 from "../../assets/images/Responsible Ai-1.png";
import image17 from "../../assets/images/DataScience 101.png";
import image18 from "../../assets/images/AWS S3 Basics.png";
import image19 from "../../assets/images/frontend develoepr.png";
const Certificates = () => {
  const certificateImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
  ];

  return (
    <section
      id="certificates"
      className="w-full py-20 border-b border-white/10"
    >
      <h2 className="text-3xl font-bold text-center mb-8">Certificates</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {certificateImages.map((image, index) => (
          <div key={index} className="flex items-center justify-center">
            <img
              src={image}
              alt={`Certificate ${index + 1}`}
              className="w-full h-auto object-cover rounded-lg shadow-lg hover:scale-105 transition-transform duration-300"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certificates;
